import { initChannel, initThirdParty, initAppId, initCurrentCity } from '@/utils/init'
import comefromConfig from '@/utils/comefromConfig'
/* 初始状态 */
const state = {
  loading: false,
  keepAlivePages: [],
  titleBar: {},
  channel: initChannel(),
  thirdParty: initThirdParty(),
  appId: initAppId(),
  /*
  * 不是app环境则为null 否则就为以下对象：
  * appInfo = {
      'versionName': '1.0.0',  // 版本号
      'platform': 'android', // ios或android
    };
  */
  appInfo: localStorage.getItem('APP_INFO') ? JSON.parse(localStorage.getItem('APP_INFO')) : null,
  currentCity: initCurrentCity(),
  locationCity: '',
  localPoint: '',
  cityList: [],

  // 申请成为合伙人的选择城市 不影响全局 单独起一个
  partnerCity: {
    // area_name: '深圳市',
    // id: 1959,
    // city_code: '0755',
    // area_code: "440300",
    // parent_area_code: "440000"
  },

  agentCardInfo: {
    got: false, // 是否已经请求过了
    homeShow: 0, // 首页是否展示健康卡 1展示，0不展示
    end_day: '',
    phone: '',
    centerPartnerStatus: null // 个人中心健康卡状态 1 没有购买卡，2 购买了未激活 ，3 购买了已激活 ，4 已经成为合伙人
  },
  comefrom:
    sessionStorage.getItem('comefrom') && comefromConfig[sessionStorage.getItem('comefrom')]
      ? comefromConfig[sessionStorage.getItem('comefrom')]
      : null, // 第三方跳转信息

  equipmentUser: {
    id: null,
    show: false,
    basic_id: null,
    default: 1 // 1是修改默认 2是修改记录数据
  },
  vipDetail: null,
  group: {
    id: '',
    name: ''
  },
  hiddenCompany: false, // 商城的营养保健需要隐藏公司名
  userAgent: 'h5'
}
export default state
